<template>
  <div class="page-container">
    <Tabs
      :tool-icon="filterIcon"
      :route-name="'videoSearch'"
      :active.sync="activeIndex"
      :tab-list="tabList"
      @change-tab="handleTabChange"
    />
    <Banner type="video" class="banner" />
    <Announcement
      :announcements="announcements"
      :interval-time="20"
      :stop-time="4000"
    />
    <div class="tab-view">
      <div class="header">
        <p class="title">精选视频</p>
        <div class="refresh" @click="refreshVideos">
          <img
            class="refresh-icon"
            :class="{ 'refresh-icon-animate': videoChangeLoading }"
            :src="refreshIcon"
            alt=""
          />
          <p>换一批</p>
        </div>
      </div>

      <ml-loading v-if="videoLoading" />
      <template v-else>
        <GridLayoutVideo
          v-if="['热门', '最新'].includes(selectedTag)"
          :videos="videos"
        />
        <VerticalLayoutVideo v-else :videos="videos" />
      </template>
      <ml-loading class="loading-bottom" v-if="bottomLoading" />
      <div v-if="isOver" class="over">
        已经到底了
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs";
import Banner from "@/components/Banner";
import Announcement from "@/components/Announcement";
import GridLayoutVideo from "@/views/video/components/GridLayoutVideo";
import VerticalLayoutVideo from "@/views/video/components/VerticalLayoutVideo";

import filterIcon from "@/assets/icons/tabbar/filter_video@2x.png";
import refreshIcon from "@/assets/icons/home/refresh@2x.png";

import { getVideos } from "@/api/video";
import { getAnnouncements } from "@/api/video";
import { getVideoCategories } from "@/api/platform";
import { changeVideos } from "@/api/video";

export default {
  name: "Video",
  components: {
    Tabs,
    Banner,
    Announcement,
    GridLayoutVideo,
    VerticalLayoutVideo
  },
  data() {
    return {
      filterIcon,
      refreshIcon,
      tabList: [],
      activeIndex: 0,
      banners: [],
      videos: [],
      announcements: [],
      tabListLoading: false,
      videoChangeLoading: false,
      videoLoading: false,
      bottomLoading: false,
      pagination: {
        page: 0,
        total: 0
      },
      isRandomModel: false
    };
  },
  computed: {
    selectedTag() {
      return this.tabList[this.activeIndex];
    },
    isOver() {
      if (this.pagination.total === 0) {
        return false;
      }
      return this.pagination.page >= this.pagination.total;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.videoLoading = true;
      const videosPending = getVideos(this.selectedTag, this.pagination);
      const tabsPending = getVideoCategories();
      const announcementsPending = getAnnouncements();
      const tabs = await tabsPending;
      tabs.unshift("最新");
      tabs.unshift("热门");
      this.tabList = tabs;
      this.announcements = await announcementsPending;
      const videosResponseData = await videosPending;
      this.videos = videosResponseData.content;
      this.pagination.page = videosResponseData.pageable.pageNumber;
      this.pagination.total = videosResponseData.totalPages;
      this.videoLoading = false;
    },
    async handleTabChange() {
      this.videoLoading = true;
      this.pagination = { page: 0, total: 0 };
      const videos = await getVideos(this.selectedTag, this.pagination);
      this.videos = videos.content;
      this.videoLoading = false;
    },
    async refreshVideos() {
      this.videoChangeLoading = true;
      this.videoLoading = true;
      this.pagination = { page: 0, total: 0 };
      const videos = await changeVideos(this.selectedTag, this.pagination);
      this.videos = videos.content;
      this.videoLoading = false;
      this.videoChangeLoading = false;
    },
    async handleScrollBottom() {
      if (this.isOver) {
        return;
      }
      this.bottomLoading = true;

      const responseGoddessData = this.isRandomModel
        ? await changeVideos(this.selectedTag, this.pagination)
        : await getVideos(this.selectedTag, this.pagination);
      this.videos = [...this.videos, ...responseGoddessData.content];
      this.pagination.page = responseGoddessData.pageable.pageNumber;
      this.pagination.total = responseGoddessData.totalPages;
      this.bottomLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  .banner {
    margin-top: 10px;
  }
  .tab-view {
    flex: 1;
    display: flex;
    flex-direction: column;
    .header {
      margin: 20px 0 12px 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: rgba(50, 51, 51, 1);
        line-height: 25px;
      }
      .refresh {
        display: flex;
        align-items: center;
        .refresh-icon {
          width: 17px;
          height: 14px;
        }
        .refresh-icon-animate {
          animation: rotateAnimation 1s 0s infinite;
        }
        p {
          margin: 0 0 0 10px;
          color: rgba(228, 191, 88, 1);
        }
      }
    }
  }
}

@keyframes rotateAnimation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
